<template>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  const { mapActions } = createNamespacedHelpers('app');

  export default {
    name: 'Logout',
    computed: {
    },
    methods: {
      ...mapActions({ removeToken: 'removeToken' })
    },
    mounted() {
      this.removeToken();
      //this.$router.push('/Portal/Security/Login');
      window.location.href = '/Portal/Security/Login';
    },
    
  }
</script>



// WEBPACK FOOTER //
// VueSrc/Security/Logout.vue